import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

export const DisclaimerModal = () => {
  const [open, setOpen] = useState(true);

  const handleAccept = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent 
        className="sm:max-w-[600px] bg-[#F8F6F2] border-none"
        data-testid="disclaimer-modal"
      >
        <DialogHeader>
          <DialogTitle 
            className="text-2xl font-semibold text-[#0B1C2D]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Disclaimer
          </DialogTitle>
          <div className="w-16 h-1 bg-[#C6A34A] mt-2"></div>
        </DialogHeader>
        <div className="text-[#2B2B2B] space-y-4 py-4">
          <p className="text-sm leading-relaxed">
            As per the rules of the Bar Council of India, we are not permitted to solicit work or advertise. By clicking "I Agree", the user acknowledges the following:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-sm text-[#4A5568]">
            <li>
              There has been no advertisement, personal communication, solicitation, invitation or inducement of any sort whatsoever from us or any of our members to solicit any work through this website.
            </li>
            <li>
              The user wishes to gain more information about us for his/her own information and use.
            </li>
            <li>
              The information about us is provided to the user only on his/her specific request and any information obtained or material downloaded from this website is completely at the user's volition.
            </li>
            <li>
              This information is not in the nature of legal advice and is not intended to constitute any form of attorney-client relationship.
            </li>
            <li>
              We are not liable for any consequence of any action taken by the user relying on material/information provided under this website.
            </li>
          </ul>
        </div>
        <DialogFooter>
          <Button 
            onClick={handleAccept}
            className="w-full sm:w-auto bg-[#0B1C2D] hover:bg-[#1A2E44] text-white px-8"
            data-testid="disclaimer-accept-btn"
          >
            I Agree
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
